import React, {useEffect, useState} from "react"
import { useNavigate, useSearchParams } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import { Box, Grid, Pagination } from '@mui/material';
import MainCard from '../../elements/MainCard';
import JobFilter from "../../molecules/filter/jobFilter";
import Spin from "../../elements/Loader/spin";
import JobList from "../../molecules/job/jobList";
import * as actions from "../../store/actions";
import Layout from "../layout/layout";
import SEO from "../../elements/SEO";

import '../layout/styles.scss';

let debounceTimer;

const JobPage = ({...props}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get('page') ? parseInt(searchParams.get('page')) : 1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { jobs, skills, isLoading, userId } = useSelector((state) => {
    return {
      jobs: state?.jobs?.jobs || [],
      isLoading: state?.jobs?.isLoading || false,
      skills: state?.skills?.skills || [],
      userId: state?.auth?.user?._id,
    }
  });

  useEffect(() => {
    const query = `?${searchParams?.toString()}&userId=${userId || ''}`;
    dispatch(actions.getJobs(query))
  }, [page, rowsPerPage, searchParams, userId]);

  const handlePaginationChange = (_, value) => {
    setPage(value);
    setSearchParams({ page: value, limit: rowsPerPage });
  }

   const fetchJob = () => {
    dispatch(actions.getJobs(`?page=${page}&limit=${rowsPerPage}&userId=${userId || ''}`));
  }

  const applyFilter = (filter) => {
    if(debounceTimer) clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      setSearchParams({ page: 1, limit: rowsPerPage, ...filter });
    },500)
  }

  const handleJobClick = (id) => () => {
    navigate(`/jobs/${id}`);
  }

  return (
    <Layout>
      <MainCard style={{ borderRadius: '12px', maxWidth: '1358px', margin: '0px auto' }}>
        <SEO title="Jobs" />
        <div className="layout-header">
          <h1>Jobs</h1>
          <JobFilter applyFilter={applyFilter}/>
        </div>
        <div className="layout-container">
          <Spin isLoading={isLoading}>
            <Box sx={{ flexGrow: 1, marginBottom: '2rem' }}>
              <Grid container spacing={2}>
                {
                  jobs?.results?.map((job) => {
                    return (
                      <Grid item xs={12} md={12} key={`job-grod-${job?.uuid}`}>
                        <JobList
                          {...props}
                          {...job}
                          handleJobClick={handleJobClick(job.uuid)}
                          fetchJob={fetchJob}
                          allSkills={skills}
                        />
                      </Grid>
                    )
                  })
                }
                {
                  !jobs?.results?.length ?
                    <Grid item xs={12} md={12}>
                      <h4>No jobs found</h4>
                    </Grid>
                  : null
                }
              </Grid>
            </Box>
          </Spin>
          {
            !isLoading ?
              <div className="flex-center">
                <Pagination count={jobs?.totalPages || 1} page={page} onChange={handlePaginationChange} />
              </div>
            : null
          }
        </div>
      </MainCard>
    </Layout>
  );
};

export default JobPage;
